(() => {
    class LandingPagesService {
        constructor($q, APIService) {
            this._q = $q;
            this.apiService = APIService;

        }

        fetchLandingPages(filter, page, count) {
            const deferred = this._q.defer()
            this.apiService.LandingPages.fetchLandingPages(filter, page, count)
                .then((response) => deferred.resolve(response.data));
            return deferred.promise;
        }

        fetchLandingPageTemplates(brandId) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.fetchLandingPageTemplates(brandId)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        fetchLandingPageById(id) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.fetchLandingPageById(id)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        uploadFeaturedImage(templateGuid, files) {
            if (!(files instanceof FileList)) {
                throw new Error("FileList expected")
            }

            const deferred = this._q.defer();
            this.apiService.LandingPages.uploadFeaturedImage(templateGuid, files)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        removeFeaturedImage(pageId) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.removeFeaturedImage(pageId)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        deleteLandingPage(pageId) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.delete(pageId)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        createLandingPage(brandId, payload) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.create({ ...payload, brandId })
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        updateLandingPage(id, payload) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.update(
                id,
                payload)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }

        updateLandingPageContent(id, payload) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.updateContent(
                id,
                payload)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }
        publishLandingPage(id, payload) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.publish(id, payload)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));

            return deferred.promise;
        }

        fetchDisplayOrder(brandId) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.fetchDisplayOrder(brandId)
                .then((response) => deferred.resolve(response.data));
            return deferred.promise;
        }

        updateDisplayOrder(items) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.updateDisplayOrder(items)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }

        updatePlacement(id, payload) {
            const deferred = this._q.defer();
            this.apiService.LandingPages.updatePlacement(id, payload)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }
    }

    angular.module("dashboard")
        .service("LandingPagesService", [ "$q", "APIService", LandingPagesService ])
})();
